import { makeStyles } from '@material-ui/core';

export const anexoStyles = makeStyles((theme) => ({
  imagemContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  productImageItem: {
    transitionProperty: 'box-shadow',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeInOut,
    textAlign: 'center',
    '&.error': {
      boxShadow: '0 3px 5px 2px rgba(207, 66, 56, 0.6)',
    },
    '&.error:hover': {
      boxShadow: '0 3px 5px 2px rgba(207, 66, 56, 0.8)',
    },
  },
  imageLoading: {
    animation: '$loading 2000ms infinite',
  },
  imageIcon: {
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle',
    position: 'absolute',
    '&.error': {
      color: 'rgb(207, 66, 56)',
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  buttonDelete: {
    color: 'rgb(207, 66, 56)',
    '&:hover': {
      backgroundColor: 'rgba(207, 66, 56, 0.1)',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(207, 66, 56, 0.3)',
      borderColor: 'rgba(207, 66, 56, 0.3)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(207, 66, 56,0.0)',
    },
  },
}));
